export default {"src":"/_next/static/media/upm.f09400ec.svg","height":128,"width":124,"blurWidth":0,"blurHeight":0};